;(function() {
function ContactMeModalService(ModalConfirmFactory, $q) {

    this.ensureContactMeSet = function(personalInfo) {
        personalInfo = personalInfo || {};

        if (personalInfo.contactMe !== undefined) {
            return $q.resolve(personalInfo.contactMe);
        }

        return ModalConfirmFactory(
            "contactme.title",
            "contactme.label",
            "yes",
            "no",
            "contactme.underYes",
            "contactme.underNo"
        ).add().result
            .then(function(result) {
                if (result) {
                    personalInfo.contactMe = (result === "confirm");
                    return personalInfo.contactMe;
                }

                return $q.reject('contactMe_not_selected');
            });
    };

    this.executeIfContactMeSet = function(personalInfo, callbackFn) {
        return this.ensureContactMeSet(personalInfo)
            .then(() => callbackFn())
            .catch(err => {
                if (err !== 'contactMe_not_selected') {
                    console.error(err);
                }
                return $q.reject(err);
            });
    };
}

angular.module("firmaren")
    .service("ContactMeModalService", ContactMeModalService);
}());
